import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormsModule} from '@angular/forms';

export interface PrAcfsSortMode {
  value: string;
  label: string;
}

@Component({
  selector: 'app-pr-acfs',
  standalone: true,
  imports: [FormsModule],
  templateUrl: './pr-acfs.component.html',
  styleUrl: './pr-acfs.component.scss'
})
export class PrAcfsComponent {
  @Input() searchQuery = '';
  @Output() searchQueryChange = new EventEmitter<string>();
  @Output() search = new EventEmitter<void>();
  @Input() showSort = false;
  @Input() sortModes: PrAcfsSortMode[] = [];
  @Input() sortBy = '';
  @Output() sortModeChange = new EventEmitter<string>();

  @Input() overlap = false;

  onQueryInput(value: string): void {
    this.searchQuery = value;
    this.searchQueryChange.emit(value);
  }

  onSearch(): void {
    this.search.emit();
  }

  onSortMode(value: string): void {
    this.sortModeChange.emit(value);
  }
}
